// @flow
import type {Node, StatelessFunctionalComponent} from 'react';

import styled from '@emotion/styled';

export const Container: StatelessFunctionalComponent<{
  children: Node,
}> = styled.div``;
